import type { ServerStatus } from '../../net/serverClient';

export function serverLabel(server: ServerStatus): string {
  switch (server.state) {
    case 'online':
      return `Server online · ${server.latencyMs} ms · v${server.version}`;
    case 'offline':
      return `Server offline${server.detail ? ` (${server.detail})` : ''}`;
    case 'waking':
      return `Waking the server… (attempt ${server.attempt})`;
    case 'checking':
      return 'Contacting server…';
    case 'unconfigured':
      return 'No server configured (offline play only)';
  }
}
